/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeviceInUseDto } from '../../models/device-in-use-dto';

export interface GetGroupDevices$Params {
  groupIdx: number;
  harvestId: number;
}

export function getGroupDevices(http: HttpClient, rootUrl: string, params: GetGroupDevices$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DeviceInUseDto>>> {
  const rb = new RequestBuilder(rootUrl, getGroupDevices.PATH, 'get');
  if (params) {
    rb.path('groupIdx', params.groupIdx, {});
    rb.path('harvestId', params.harvestId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DeviceInUseDto>>;
    })
  );
}

getGroupDevices.PATH = '/api/harvests/{harvestId}/group/{groupIdx}/devices';
